(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };

  // src/js/components/mediaModal.js
  var MediaModal = class {
    constructor(_params) {
      this.elements = __spreadValues({}, _params.elements);
      this.settings = {
        modal: {
          hidden_class: "is-hidden",
          shown_class: "js-alert-shown"
        },
        body: {
          active_class: "modal-active"
        }
      };
    }
    static create() {
      const modal = window.Store.app.theBody.querySelector(".js-media-modal");
      if (!modal)
        return null;
      const modal_inner = modal.querySelector(".js-modal-inner");
      if (!modal_inner)
        return null;
      const close_elements = modal.getElementsByClassName("js-modal-close");
      const previous_element = modal.getElementsByClassName("js-modal-previous")[0];
      const next_element = modal.getElementsByClassName("js-modal-next")[0];
      const video_element = modal.getElementsByClassName("js-video-insert");
      const image_full = modal.getElementsByClassName("js-image-full");
      const image_medium = modal.getElementsByClassName("js-image-medium");
      const image_base = modal.getElementsByClassName("js-image-base");
      const params = {
        elements: {
          modal,
          inner: {
            element: modal_inner,
            height: null,
            image: {
              full: image_full,
              medium: image_medium,
              base: image_base
            },
            video: video_element
          },
          gallery: null,
          close_elements,
          previous_element,
          next_element,
          show_modal: false
        }
      };
      const obj = new MediaModal(params);
      obj.updateModalInnerHeight();
      obj.init();
      return obj;
    }
    init() {
      const ua = window.navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      const scope = this;
      const removeLoadingClass = () => {
        scope.elements.modal.classList.remove("is-loading");
      };
      this.iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
      this.initialHeight = window.innerHeight;
      this.elements.inner.image.base[0].addEventListener("load", removeLoadingClass);
      this.elements.inner.video[0].addEventListener("load", removeLoadingClass);
      this.elements.previous_element.addEventListener("click", (direction) => this.updateGalleryObject(-1));
      this.elements.next_element.addEventListener("click", (direction) => this.updateGalleryObject(1));
    }
    showModal(data) {
      const siteContainer = window.Store.app.theBody.querySelector(".js-siteContainer");
      const scrollElement = window.Store.app.theBody.querySelector(".o-scroll");
      this.elements.show_modal = true;
      window.Store.components.navigation.obj.elements.header.element.classList.add("is-hidden");
      if (window.Store.scrollbar.element.smooth) {
        let scrollWaitInterval = setInterval(() => {
          if (!document.documentElement.classList.contains("has-scroll-scrolling")) {
            this.elements.modal.style.top = `${window.Store.scrollbar.y}px`;
            clearInterval(scrollWaitInterval);
            this.elements.modal.style.transform = "scale(1)";
          }
        }, 100);
      } else {
        this.lastYPosition = window.Store.scrollbar.y;
        if (this.iOSSafari) {
          if (this.initialHeight === window.innerHeight) {
            scrollElement.style.height = "calc(100vh - 81px)";
            this.elements.modal.style.height = "calc(100vh - 81px)";
          } else {
            scrollElement.style.height = "100vh";
          }
          this.elements.modal.style.transform = `scale(1) translateY(${this.lastYPosition}px)`;
          siteContainer.style.transform = `translateY(-${this.lastYPosition}px)`;
        }
      }
      switch (data.type) {
        case "image":
          this.updateContentSource(data.sources);
          break;
        case "video":
          this.elements.inner.video[0].setAttribute("src", `https://www.youtube.com/embed/${data.videoId}`);
          this.elements.inner.video[0].setAttribute("title", data.videoTitle);
          break;
        case "gallery":
          const galleryImages = data.galleryElement.querySelectorAll(".js-gallery-toggler");
          const activeImageIndex = [...galleryImages].indexOf(data.activeElement);
          this.gallery = {
            "el": data.galleryElement,
            "galleryImages": galleryImages,
            "activeImageIndex": activeImageIndex
          };
          this.updateContentSource(data.sources);
          break;
      }
      this.elements.modal.classList.add(`is-${data.type}`);
      this.elements.modal.classList.add("is-loading");
      this.elements.modal.classList.remove(this.settings.modal.hidden_class);
      window.Store.app.theBody.classList.add(this.settings.body.active_class);
      window.Store.scrollbar.element.stop();
      this.addCloseListener();
      this.adjustVideoRatio();
    }
    updateGalleryObject(direction) {
      if (this.elements.modal.classList.contains("is-loading")) {
        return;
      }
      let activeIndex;
      if (this.gallery.activeImageIndex === 0 && direction === -1) {
        activeIndex = this.gallery.galleryImages.length - 1;
      } else if (this.gallery.activeImageIndex === this.gallery.galleryImages.length - 1 && direction === 1) {
        activeIndex = 0;
      } else {
        activeIndex = this.gallery.activeImageIndex + parseInt(direction);
      }
      const newActiveImage = this.gallery.galleryImages[activeIndex];
      const newImageSource = {
        "base": newActiveImage.getAttribute("data-source-base"),
        "full": newActiveImage.getAttribute("data-source-full"),
        "medium": newActiveImage.getAttribute("data-source-medium")
      };
      this.updateContentSource(newImageSource);
      this.elements.modal.classList.add("is-loading");
      this.gallery.activeImageIndex = activeIndex;
    }
    updateContentSource(imageSources) {
      for (let prop in imageSources) {
        this.elements.inner.image[prop][0].setAttribute("data-srcset", imageSources[prop]);
        if (prop === "base") {
          this.elements.inner.image[prop][0].setAttribute("src", imageSources[prop]);
        } else {
          this.elements.inner.image[prop][0].setAttribute("srcset", imageSources[prop]);
        }
      }
    }
    hideModal() {
      const siteContainer = window.Store.app.theBody.querySelector(".js-siteContainer");
      const scrollElement = window.Store.app.theBody.querySelector(".o-scroll");
      this.elements.show_modal = false;
      const callback = () => {
        this.clearContentSources();
        this.gallery = null;
        this.elements.modal.removeEventListener("transitionend", callback);
        this.elements.modal.classList.remove("is-image", "is-video", "is-gallery", "is-loading");
        this.elements.modal.style.top = "";
        this.elements.modal.style.transform = "";
        window.Store.app.theBody.classList.remove(this.settings.body.active_class);
        window.Store.scrollbar.element.start();
      };
      if (!window.Store.scrollbar.element.smooth) {
        scrollElement.style.height = "";
        siteContainer.style.transform = "";
        this.elements.modal.style.transform = "";
        this.elements.modal.style.height = "";
        window.Store.scrollbar.scrollTo(this.lastYPosition, { "duration": 0 });
      }
      this.elements.modal.classList.add(this.settings.modal.hidden_class);
      this.elements.modal.addEventListener("transitionend", callback);
    }
    clearContentSources() {
      for (let prop in this.elements.inner.image) {
        this.elements.inner.image[prop][0].setAttribute("data-srcset", "");
        if (prop === "base") {
          this.elements.inner.image[prop][0].setAttribute("src", "");
        } else {
          this.elements.inner.image[prop][0].setAttribute("srcset", "");
        }
      }
      this.elements.inner.video[0].setAttribute("src", "");
    }
    addCloseListener() {
      if (this.elements.close_elements.length > 0) {
        for (let i = 0; i < this.elements.close_elements.length; i++) {
          const close_element = this.elements.close_elements[i];
          close_element.addEventListener("click", this.hideModal.bind(this));
        }
      }
      window.Store.app.theBody.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !this.elements.modal.classList.contains(this.settings.modal.hidden_class)) {
          this.hideModal();
        }
      });
    }
    adjustVideoRatio() {
      const $videoWrapper = this.elements.inner.element;
      const desiredRatio = 16 / 9;
      const newWidth = `${parseInt($videoWrapper.offsetHeight * desiredRatio)}px`;
      $videoWrapper.style.width = newWidth;
    }
    updateModalInnerHeight() {
      return this.elements.inner.height = this.elements.inner.element.getBoundingClientRect().height;
    }
    updateModalInnerScroll() {
      if (window.Store.scrollbar.world.w < 991) {
        this.elements.inner.scroll_desktop.element.style.overflowY = `unset`;
        this.elements.inner.scroll_mobile.scroll_height = this.elements.inner.scroll_mobile.element.scrollHeight;
        if (this.elements.inner.scroll_mobile.scroll_height > this.elements.inner.height) {
          this.elements.inner.scroll_mobile.element.style.overflowY = `auto`;
          return;
        }
        this.elements.inner.scroll_mobile.element.style.overflowY = `unset`;
        return;
      }
      this.elements.inner.scroll_mobile.element.style.overflowY = `unset`;
      this.elements.inner.scroll_desktop.scroll_height = this.elements.inner.scroll_desktop.element.scrollHeight;
      if (this.elements.inner.scroll_desktop.scroll_height > this.elements.inner.height) {
        this.elements.inner.scroll_desktop.element.style.overflowY = `auto`;
        return;
      }
      this.elements.inner.scroll_desktop.element.style.overflowY = `unset`;
    }
    globalUpdateModalElements() {
      this.updateModalInnerHeight();
      this.updateModalInnerScroll();
    }
  };
  function render() {
    window.Store.components.mediaModal.obj = MediaModal.create();
  }
  window.Store.components.mediaModal.render = render;
})();
